class Vacatures {
	constructor(config) {
		this.config = Object.assign({
			scope: '.vacatures',
		}, config);

		$(document).ready(() => {
			this.$scope = $(this.config.scope);

			if (this.$scope.length > 0) {
				this.init();
			}
		});
	}

	init() {
		this.$scope.each((_, scope) => {
			this.#bindEvents(scope);
		});
	}

	#bindEvents(scope) {
		const $col = $(scope).find('.vacatures__info-col');

		$(scope).find('.vacature-card').on('click', (e) => {
			const id = $(e.currentTarget).data('id');
			const $info = $(scope).find(`.vacature-info[data-id="${id}"]`);
			const isActive = $(e.currentTarget).hasClass('active');

			$(scope).find('.vacature-card').removeClass('active');
			$(scope).find('.vacature-info').removeClass('active');

			if (isActive) {
				$col.removeClass('open');
				return;
			}

			$(e.currentTarget).addClass('active');
			$info.addClass('active');
			$col.addClass('open');

			if (window.innerWidth < 992) {
				setTimeout(() => {
					$col[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
				}, 50);
			}
		});

		$(scope).find('.vacature-info__close').on('click', () => {
			$(scope).find('.vacature-card').removeClass('active');
			$(scope).find('.vacature-info').removeClass('active');
			$col.removeClass('open');
		});
	}
}

export default new Vacatures;